// @flow

import type { ServiceSectionStatusesState } from "./types";

export const onGetServiceSectionStatusesSuccess = (state: ServiceSectionStatusesState) => ({
  payload,
}: *) => ({
  ...state,
  error: null,
  list: payload,
});

export const onGetServiceSectionStatusesError = (state: ServiceSectionStatusesState) => ({
  payload,
}: *) => ({
  ...state,
  error: payload,
});
